import { ROOT_URL } from '@/constants/configConstants';
import { NEW_VIEW } from '@/constants/dashboardConstants';

export const getURLOverride = (): string => {
  const { origin } = new URL(ROOT_URL || '', window.location.origin);

  return `${origin}/clientlib`;
};

export function createLibraryTemplateInstance({
  instanceName,
  templateRevisionId,
  projectId,
  templateId,
  viewId
}: {
  instanceName: string;
  templateRevisionId: string;
  projectId: string;
  templateId: string;
  viewId: string;
}) {
  const updatedInstance = {
    metadata: { isStatic: false },
    config: '{}',
    instanceName,
    projectId,
    order: 0,
    queryBuilderId: '',
    source: 'project',
    templateRevisionId,
    templateId: templateId,
    templateName: instanceName,
    useDefaultConfig: true,
    userSkippedVersion: Date.now(),
    viewId: viewId === NEW_VIEW ? null : viewId
  };
  return updatedInstance;
}
